Service = App.loadClass 'core::Angular/Service'

class exports.MapsConversionMatrixService extends Service
    constructor: (@http) ->
        undefined

    checkUnconfirmed: () =>
        return @http.post 'backend/grower/maps-conversion/check-unconfirmed'

    getImage: (path) =>
        return @http.post 'backend/grower/maps-conversion/view-image', { path }

    confirm: (parentsId, ingredion_survey) =>
        return @http.post 'backend/grower/maps-conversion/confirm', { parentsId, ingredion_survey }
